import { makeAutoObservable } from "mobx";
import Storage from "utils/storage";
import { get_time } from "api/v4/market";

export enum LayoutEnum {
  classic = "classic",
  advanced = "advanced",
  fullscreen = "fullscreen",
}

export enum BreakpointEnum {
  xl = "xl",
  lg = "lg",
  md = "md",
  sm = "sm",
}

export enum ClsUpDownEnum {
  up = "up-color",
  down = "down-color",
}

interface StateProps {
  clientSideReady: boolean;
  breakpoint: BreakpointEnum;
  windowInnerWidth: WithUndefined<number>;
  layout: LayoutEnum;
  time: { server: number; local: number };
}

const app = makeAutoObservable(
  {
    clientSideReady: false as StateProps["clientSideReady"],
    breakpoint: BreakpointEnum.lg as StateProps["breakpoint"],
    windowInnerWidth: undefined as StateProps["windowInnerWidth"],
    layout: LayoutEnum.advanced as StateProps["layout"],
    time: {
      server: 0,
      local: 0,
    } as StateProps["time"],

    get isH5(): boolean {
      return this.breakpoint === BreakpointEnum.sm;
    },

    updateState(payload: Partial<StateProps>) {
      for (const key in payload) {
        this[key] = payload[key];
      }
    },

    initLayout() {
      this.layout = (() => {
        const layout = Storage.get("layout");
        if (layout && LayoutEnum[layout]) return layout;
        return LayoutEnum.advanced;
      })();
    },

    getServerTime() {
      get_time().then(({ serverTime }) => {
        this.updateState({
          time: {
            server: serverTime as any,
            local: Date.now(),
          },
        });
      });
    },
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default app;
